<template>
	<div>
		<div v-if="loading">
			<v-progress-linear class="my-3" color="primary" height="4" indeterminate rounded></v-progress-linear>
			<div class="text-center success--text">در حال دریافت اطلاعات...</div>
		</div>
		<div v-else>
			<v-row v-if="localData && localData.memberModel">
				<v-col cols="12" md="12" class="d-flex flex-wrap">
					<v-chip class="" color="secondary" outlined style="cursor: pointer;">
						<v-icon left>
							mdi-account-outline
						</v-icon>
						{{ localData.memberModel.fullName }}
						(&lrm;{{ localData.memberModel.userName }})
					</v-chip>
					<v-chip class="mx-2" color="secondary" outlined>
						<v-icon left small>
							mdi-cellphone
						</v-icon>
						موبایل: {{ localData.memberModel.mobile }}
					</v-chip>
					<v-chip class="" color="secondary" outlined>
						وضعیت خوش حسابی:
						<ReliabilityManager :member="localData.memberModel" style="cursor:pointer" />
					</v-chip>
				</v-col>
			</v-row>
			<v-divider class="my-3" />
			<v-row v-if="localData" class="loan-cards mb-3">
				<v-col cols="12" md="12">
					<ManageLoanItem :data="localData" :showInstallmentsBtn="false" @loadData="loadData" :area="area" />
				</v-col>
			</v-row>

			<installments v-if="localData" :userloan="localData" :area="area" @changed="loadData()" />
		</div>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'
	import ManageLoanItem from '@/components/forms/ManageLoanItem.vue'

	export default {
		name: 'UserLoanDetailView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'installments': () => import('@/components/forms/Installments.vue'),
			'ManageLoanItem': ManageLoanItem,
		},
		props: {
			userLoanId: { type: String },
			area: { type: String },
		},
		data() {
			return {
				loading: false,
				errorMessages: '',
				localData: null,
			}
		},
		computed: {

		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get(`${this.area}/userloan/get/` + this.userLoanId, null)
					.then(response => {
						this.localData = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
		},
	}
</script>
<style></style>
